import { useEffect, useState, useRef, useCallback } from "react";
import io from "socket.io-client";
const SOCKET_SERVER_URL = "devapi.maruti.dev/";
const SOCKET_SERVER_URL_LIVE = "api.maruti.dev/";

export default function useOurWebsocket() {
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);

  const [state, setState] = useState({
    receivedMessages: {},
    receivedlottrey: {},
    receivedMatchoddsHG: {},
    receivedlottreybookDetails: {},
    receivedMatchodds: {},
    receivedToken: {},
    receivedMMOpenBets: [],
    receivedmarketIdbookDetailsMM: [],
    receivedMultiMarket: [],
    receivedMultiMarketUpdates: [],
    receivedBookmaker: {},
    receivedOtherBookmaker: {},
    receivedMnbookmaker: {},
    receivedFancysession: {},
    receivedFancywpMarket: {},
    receivedFancyOddEven: {},
    receivedFancyballByBall: {},
    receivedFancyWiningSeat: {},
    receivedFancyOnlyOver: {},
    receivedBetlistData: {},
    receivedBetlistData2: {},
    receivedwalletData: {},
    receivedBookData: {},
    receivedAllBookData: {},
    receivedcashoutBm: {},
    receivedcashoutMO: {},
    receivedBookFancy: {},
    receivedBookDigit: {},
    receivedToss: {},
    receivedunderOve0: {},
    receivedunderOve1: {},
    receivedunderOve2: {},
    receivedunderOve3: {},
    receivedMoArray: {},
    getAllBets: [],
    receivedunderOvebook: {},
    receivedMinMax: {},
    receivedMinMaxFancy: {},
    receivedExchange: {},
    receivedBookUserSide: {},
  });

  const getURL = () =>
    process.env.REACT_APP_ENV === "development"
      ? SOCKET_SERVER_URL
      : SOCKET_SERVER_URL_LIVE;

  const eventHandlers = {
    inplaymatchdetails: (data) =>
      setState((p) => ({
        ...p,
        receivedMessages: data,
        receivedMoArray: data?.data?.lottretMarket,
      })),
    lottretMarketID: (data) =>
      data.lottretMarket &&
      setState((p) => ({ ...p, receivedlottrey: data.lottretMarket })),
    matchOddsMarketIds: (data) =>
      setState((p) => ({ ...p, receivedMatchodds: data })),
    getmarketminmaxdata: (data) =>
      setState((p) => ({ ...p, receivedMinMax: data })),
    getmarketminmaxdataFancy: (data) =>
      setState((p) => ({ ...p, receivedMinMaxFancy: data })),
    fancyBookUserSide: (data) =>
      setState((p) => ({ ...p, receivedBookUserSide: data })),
    exchangedata: (data) => setState((p) => ({ ...p, receivedExchange: data })),
    marketIdbookDetailsByEventId: (data) =>
      setState((p) => ({ ...p, receivedAllBookData: data })),
    createToken: (data) => setState((p) => ({ ...p, receivedToken: data })),
    AllOPenBets: (data) => setState((p) => ({ ...p, getAllBets: data })),
    matchOddsMarketIdsHG: (data) =>
      setState((p) => ({ ...p, receivedMatchoddsHG: data })),
    lottreybookDetails: (data) =>
      setState((p) => ({ ...p, receivedlottreybookDetails: data })),
    winningSeat: (data) =>
      setState((p) => ({ ...p, receivedFancyWiningSeat: data })),
    multiMarketOpenBets: (data) =>
      setState((p) => ({ ...p, receivedMMOpenBets: data })),
    marketIdbookDetailsMultiMarket: (data) =>
      setState((p) => ({ ...p, receivedmarketIdbookDetailsMM: data })),
    multiMartketOddsUpdate: (data) =>
      setState((p) => ({ ...p, receivedMultiMarket: data })),
    multimarketUpdate: (data) =>
      setState((p) => ({ ...p, receivedMultiMarketUpdates: data })),
    bookmakerMarketIds: (data) =>
      setState((p) => ({ ...p, receivedBookmaker: data })),
    otherBookmakerMarketIds: (data) =>
      setState((p) => ({ ...p, receivedOtherBookmaker: data })),
    minibookmakerMarketIds: (data) =>
      setState((p) => ({ ...p, receivedMnbookmaker: data })),
    sessionMarketIds: (data) =>
      setState((p) => ({ ...p, receivedFancysession: data })),
    wpMarketIds: (data) =>
      setState((p) => ({ ...p, receivedFancywpMarket: data })),
    oddEvenMarketIds: (data) =>
      setState((p) => ({ ...p, receivedFancyOddEven: data })),
    ballbyballmaketIds: (data) =>
      setState((p) => ({ ...p, receivedFancyballByBall: data })),
    onlyOverMarketIds: (data) =>
      setState((p) => ({ ...p, receivedFancyOnlyOver: data })),
    getbetlistdata: (data) =>
      setState((p) => ({ ...p, receivedBetlistData: data })),
    getbetlistdata2: (data) =>
      setState((p) => ({ ...p, receivedBetlistData2: data })),
    userLoginBalance: (data) =>
      setState((p) => ({ ...p, receivedwalletData: data })),
    marketIdbookDetails: (data) =>
      setState((p) => ({ ...p, receivedBookData: data })),
    cashOOutBm: (data) => setState((p) => ({ ...p, receivedcashoutBm: data })),
    cashOOut: (data) => setState((p) => ({ ...p, receivedcashoutMO: data })),
    getFancyBookDATAuserSide: (data) =>
      setState((p) => ({ ...p, receivedBookFancy: data })),
    getdigitbookDataByMarketId: (data) =>
      setState((p) => ({ ...p, receivedBookDigit: data })),
    tossMarketIds: (data) => setState((p) => ({ ...p, receivedToss: data })),
    overundermarketId0: (data) =>
      setState((p) => ({ ...p, receivedunderOve0: data })),
    overundermarketId1: (data) =>
      setState((p) => ({ ...p, receivedunderOve1: data })),
    overundermarketId2: (data) =>
      setState((p) => ({ ...p, receivedunderOve2: data })),
    overundermarketId3: (data) =>
      setState((p) => ({ ...p, receivedunderOve3: data })),
    marketIdbookDetailsUnderOver: (data) =>
      setState((p) => ({ ...p, receivedunderOvebook: data })),
  };

  useEffect(() => {
    const socket = io(process.env.REACT_APP_BASE_URL, {
      transports: ["websocket"],
    });
    socketRef.current = socket;
    socket.on("connect", () => setIsConnected(true));
    socket.on("disconnect", () => setIsConnected(false));
    Object.entries(eventHandlers).forEach(([event, fn]) =>
      socket.on(event, fn)
    );
    return () => {
      Object.keys(eventHandlers).forEach((event) => socket.off(event));
      socket.disconnect();
    };
  }, []);

  const sendMessage = useCallback((event, payload) => {
    socketRef.current?.emit(event, payload);
  }, []);

  const onSocketEvent = useCallback((event, handler) => {
    const socket = socketRef.current;

    if (!socket) return () => { };

    socket.on(event, handler);

    return () => {
      socket.off(event, handler);
    };
  }, []);

  const clearCashout = useCallback(() => {
    setState((p) => ({ ...p, receivedcashoutMO: {}, receivedcashoutBm: {} }));
  }, []);

  return { isConnected, ...state, sendMessage, onSocketEvent, clearCashout };
}
